module.exports = __webpack_public_path__ + "img/spaceship-02.4ebccc11.png";